// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".root__E3TPid3v{display:flex;flex-direction:column;height:100%;padding:0 8px}.popover__NVRo0Tha{position:absolute;z-index:7000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "root__E3TPid3v",
	"popover": "popover__NVRo0Tha"
};

/*** EXPORTS FROM exports-loader ***/
export default ___CSS_LOADER_EXPORT___.toString();
